import {
    ITV_GAS_LPG_CAR,
    getConstant,
} from 'commons/js/constants'

export const vehicleInspectionStationParams = {
    place_id: getConstant('COUNTRY_PLACE_ID'),
    vehicle_filter: ITV_GAS_LPG_CAR,
}
